import React from 'react';
import type { BoardSummaryVo, TAttentionCard } from 'types/insuranceBilling';
import s from './s.module.less';

// NEEDS ATTENTION 卡片区（原型 09/09 起，从 KPI 行挪到表格上方）。
// 只放 payer 退回来的两种：denied 与 rejected。建不出 claim 的 visit 不在这里 ——
// 它们归 Klarity preparation 那个 tab。
//
// 数据是 summary.attention：服务端只回 count > 0 的项，label 不带数字（"claims denied"）。
// 两张都没有时整个区块消失：一条常驻的「all clear」在大多数日子里都是家具，
// 区块不在本身就是 all-clear 信号。
type Props = {
    cards: BoardSummaryVo['attention'];
    // 当前被卡片激活的 card（同时只会有一个）
    activeKey: TAttentionCard | null;
    onToggle: (key: TAttentionCard) => void;
};

const AttentionCards = ({ cards, activeKey, onToggle }: Props) => {
    const visible = cards.filter((c) => c.count > 0);
    if (!visible.length) return null;

    return (
        <>
            <div className={s.attnLabel}>NEEDS ATTENTION</div>
            <div className={s.attnRow}>
                {visible.map((c) => {
                    const on = activeKey === c.key;
                    return (
                        <button
                            key={c.key}
                            type="button"
                            className={`${s.attnCard} ${on ? s.attnCardOn : ''}`}
                            onClick={() => onToggle(c.key)}
                        >
                            <span className={s.attnLine}>
                                <b>{c.count}</b> {c.label}
                            </span>
                            <span className={`${s.attnCta} ${on ? s.attnCtaOn : ''}`}>
                                {on ? 'Showing below' : 'See details ›'}
                            </span>
                        </button>
                    );
                })}
            </div>
        </>
    );
};

export default AttentionCards;
